export const toggleAria = (element, aria) => {
	if (element != null && aria != null) {
		let ariaAttr = element.getAttribute(aria);
		if (ariaAttr == "true") element.setAttribute(aria, "false");
		else {
			element.setAttribute(aria, "true");
		}
	}
};
